import { SVGProps } from 'react';

const Orbit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.34 6.484A10 10 0 0 1 10.267 21.85m-6.607-4.334a10 10 0 0 1 10.08-15.364M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0m6-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0M7 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Orbit;
